import moment from 'moment';

//resp to blob to download
export const downloadFileBlob = (resp, name, type) => {
    const blob = new Blob([resp], { type: type });
    const fileURL = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = name;
    link.click();
}

//resp to blob to base64
export const blobToSRC = (resp, type = 'image/jpg') => {

    const blob = new Blob([resp], { type: type });
    var reader = new FileReader();
    reader.readAsDataURL(blob);

    return reader
}


export const formatDate = (value, format = 'DD/MM/YYYY') => {
    if (!value)
        return '';
    return moment(value).format(format)
}


export const ellipsis = (value, limit = 20) => {
    if (!value)
        return '';
    else if(limit && value.length > limit) {
        return value.substring(0, limit).concat('...');
    }
    return value;
}


// WEBPACK FOOTER //
// ./src/util/UtilFunction.js